import { Typography, makeStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";

import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import editorConfiguration from "../../../../util/EditorConfiguration";

const frontendUrl = process.env.REACT_APP_CINEFAN_WEB_HOSTNAME;

const useStyles = makeStyles((theme) => ({
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  permalink: {
    fontSize: "14px",
    marginBottom: "40px",
    color: "#333333",

    "& .link": {
      display: "inline",
      color: "#306F9D",
      margin: "0 10px",
      "& input": {
        padding: "7px 14px",
        fontSize: "13px",
      },
    },
    "& button": {
      padding: "2px 20px",
      textTransform: "inherit",
      color: "#727272",
    },
  },
}));

const GeneralContent = (props) => {
  const classes = useStyles();
  const {
    details,
    activeLang,
    control,
    register,
    setValue,
    getValues,
    disabled,
    isEditPermalink,
    setEditPermalink,
    isSlugInvalid,
    setIsSlugInvalid,
  } = props;
  // keep in case
  // const [clonedEnPermalink, setClonedEnPermalink] = useState(
  //   details.localizations.en.slug
  // );
  // const [clonedTcPermalink, setClonedTcPermalink] = useState(
  //   details.localizations.tc.slug
  // );
  // const [isEnSlugInvalid, setIsEnSlugInvalid] = useState(false);
  // const [isTcSlugInvalid, setIsTcSlugInvalid] = useState(false);
  // const [isEditPermalink, setEditPermalink] = useState({
  //   en: false,
  //   tc: false,
  // });

  const [clonedPermalink, setClonedPermalink] = React.useState("");

  return (
    <>
      <Controller
        name={`localizations.${activeLang}.title`}
        control={control}
        shouldUnregister={false}
        render={({ field, fieldState: { error } }) => (
          <TextField
            label="Page Title"
            variant="outlined"
            margin="dense"
            className={classes.textInput}
            {...field}
            defaultValue={details.localizations[activeLang].title}
            error={!!error}
            helperText={error ? error.message : ""}
          />
        )}
      />
      <div className={classes.permalink}>
        Permalink:
        <div className="link">
          {!isEditPermalink && (
            <>
              <input
                value={
                  getValues(`localizations.en.slug`)
                    ? getValues(`localizations.en.slug`)
                    : details.localizations.en.slug
                }
                type="hidden"
                {...register("localizations.en.slug")}
              />
              <input
                value={
                  getValues(`localizations.en.slug`)
                    ? getValues(`localizations.en.slug`)
                    : details.localizations.en.slug
                }
                type="hidden"
                {...register("localizations.tc.slug")}
              />
              {frontendUrl || "https://cinefan.com.hk"}/
              {getValues(`localizations.en.slug`)
                ? getValues(`localizations.en.slug`)
                : details.localizations.en.slug}
              <Button
                variant="outlined"
                onClick={() => {
                  setEditPermalink(true);
                  setClonedPermalink(
                    getValues(`localizations.en.slug`)
                      ? getValues(`localizations.en.slug`)
                      : details.localizations.en.slug
                  );
                }}
              >
                Edit
              </Button>
            </>
          )}
          {isEditPermalink && (
            <>
              <span>{frontendUrl || "https://cinefan.com.hk"}/</span>
              <Controller
                name={`localizations.en.slug`}
                control={control}
                defaultValue={details.localizations.en.slug}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    variant="outlined"
                    margin="dense"
                    {...field}
                    error={isSlugInvalid}
                    helperText={isSlugInvalid && "Slug required"}
                    onChange={(e) => {
                      field.onChange(e);
                      setValue("localizations.en.slug", e.target.value);
                      setValue("localizations.tc.slug", e.target.value);
                    }}
                  />
                )}
              />
              <Button
                variant="outlined"
                onClick={() => {
                  if (getValues(`localizations.en.slug`)) {
                    setIsSlugInvalid(false);
                    setEditPermalink(false);
                  } else {
                    setIsSlugInvalid(true);
                  }
                }}
              >
                OK
              </Button>
              <Button
                variant="text"
                onClick={() => {
                  setValue(`localizations.en.slug`, clonedPermalink);
                  setIsSlugInvalid(false);
                  setEditPermalink(false);
                }}
              >
                Cancel
              </Button>
            </>
          )}
        </div>
      </div>

      {activeLang === "en" && (
        <Controller
          name={`localizations.en.content`}
          control={control}
          defaultValue={details.localizations.en.content}
          render={({ field, fieldState: { error } }) => (
            <CKEditor
              editor={Editor}
              config={editorConfiguration}
              data={field.value}
              disabled={disabled}
              onReady={(editor) => {
                editor.setData(
                  details.localizations.en.content
                );
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setValue(`localizations.en.content`, data);
                field.onChange(data);
              }}
            />
          )}
        />
      )}
      {activeLang === "tc" && (
        <Controller
          name={`localizations.tc.content`}
          control={control}
          defaultValue={details.localizations.tc.content}
          render={({ field, fieldState: { error } }) => (
            <CKEditor
              editor={Editor}
              config={editorConfiguration}
              data={field.value}
              disabled={disabled}
              onReady={(editor) => {
                editor.setData(
                  details.localizations.tc.content
                );
              }}
              onChange={(event, editor) => {
                const data = editor.getData();
                setValue(`localizations.tc.content`, data);
                field.onChange(data);
              }}
            />
          )}
        />
      )}
    </>
  );
};

export default GeneralContent;
